import type * as React from "react";
import classNames from "classnames";

export interface CardProps {
  size?: CardSize;
  isHoverable?: boolean;
  "data-test-id"?: string;
  bordered?: boolean;
}

export enum CardSize {
  TINY,
  SMALL,
  DEFAULT,
}

/**
 * @deprecated
 * @param props
 */
const Card: React.FunctionComponent<CardProps & JSX.IntrinsicElements["div"]> = (props) => {
  const { size, isHoverable, className, bordered = true, ...elementProps } = props;

  const cls = classNames(
    {
      scha__card: true,
      "scha__card--small": size === CardSize.SMALL,
      "scha__card--tiny": size === CardSize.TINY,
      "scha__card--bordered": bordered,
    },
    className
  );

  return <div className={cls} {...elementProps} />;
};

Card.defaultProps = {
  size: CardSize.DEFAULT,
};

export default Card;
